import './bml-cases.scss';
const TEMPLATE = `
<section class="cases fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6 col-lg-6">
                <p class="section-label" data-animate-child>Діагностичні кейси</p>
            </div>
            <div class="col-md-6 col-lg-6">
                <h3 data-animate-child data-delay="200">Наш досвід у дії</h3>
                <p class="case-paragraph-start" data-animate-child data-delay="400">
                    Результати досліджень наших патоморфологів демонструють, як сучасна патоморфологія допомагає
                    вирішувати складні клінічні виклики, та дає нові можливості для лікування.
                </p>
                <a class="case-link-start" href="/cases" data-animate-child data-delay="600">
                    Дізнатися більше
                </a>
            </div>
        </div>
        <div class="accordion-cases" id="accordion-cases-2" data-section="accordion"
             data-animate-child data-delay="800"></div>
    </div>
</section>
`;

class BmlCases extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
    }
}

customElements.define('bml-cases', BmlCases);
